import { Injectable } from '@angular/core';
import { FAQ } from '../models/faq';

const faqPromise: Promise<FAQ[]> = Promise.resolve([
  {
    id: "faq1",
    delay:100,
    cssclass:"bx bx-globe icon-help",    
    heading:"How do I sign up to Client Data Management software?",
    data:"<p>Shoot us a quick email at <strong>customerservice@sficompliance.com</strong> or call at "+
        "<strong>303-649-1304</strong> to request a new user login. To set up your account we will need to know the following: first and last name, the company you work for, "+
        "what site you want to view, and the email you want the reports sent to.</p>"
  },
  {
    id: "faq2",
    delay:200,
    cssclass:"bx bx-lock-open icon-help",    
    heading:"I am having trouble logging in, what do I do?",
    data:"<p>When on the client login page, you can select forgot password and reset your password using your email.</p>"
  },
  {
    id: "faq3",
    delay:300,
    cssclass:"bx bx-help-circle icon-help",    
    heading:"I have reset my password and still cannot login.",
    data:"<p>If you are still having issues contact us at <strong>303-649-1304</strong> or <strong>customerservice@sficompliance.com</strong> and we can set a temporary password for you.</p>"
  },
  {
    id: "faq4",
    delay:400,
    cssclass:"bx bx-envelope icon-help",    
    heading:"I received an email that I have a new report, how do I view this on the DMS?",
    data:"<p>In order to view new reports, you will need to go to dms.sficompliance.com and login. Once you are logged in, on the left-hand side select “Inspections” then “Jobsite Inspections” and you will see all the reports pull up for your site. From here you can sort by report number, date, site and inspector. If you show no reports on this screen please contact us so we can resolve the issue for you.</p>"
  },
  {
    id: "faq5",
    delay:500,
    cssclass:"bx bx-envelope icon-help",    
    heading:"I am not receiving the new report emails.",
    data:"<p>If you are not receiving emails from us, please confirm that we are an approved sender in your mailing system. You should allow emails from notifications@sficompliance.com in order to get password reset emails, new report notifications and to adjust site contact lists.</p>"
  },
  {
    id: "faq6",
    delay:600,
    cssclass:"bx bx-mobile icon-help",    
    heading:"Where do I go to download the app?",
    data:"<p>Our mobile DMS app is available on the Google Play Store and the Apple App store under “SFI DMS Safety App” </p>"+
        "<div class='row' style='padding-top: 10px;padding-bottom: 10px;' data-aos='fade-up' data-aos-delay='200'>"+
        "<div class='col-lg-3 col-3 text-center'><a href='https://play.google.com/store/apps/details?id=com.sfi.mobileapp' target='_blank'><i class='fa fa-android' style='font-size: 64px;color: gray;'></i></a></div>"+
        "<div class='col-lg-3 col-3 text-center'><a href='https://apps.apple.com/app/sfi-dms-safety-app/id1466584086' target='_blank'><i class='fa fa-apple' style='font-size: 64px;color: gray;'></i></a></div>"+
        "</div>"
  },
  
]);


@Injectable({
  providedIn: 'root'
})
export class FaqService {

  constructor() { }

  getFAQ(){
      return faqPromise;
  } 
  
  
}
